import { Skeleton } from "@mui/material";

import useBingImage from "./useBingImage";
import classes from "./BingImage.module.css";

export default function BingImage({ entity, category, className }) {
  const { loading, image } = useBingImage(entity, category);
  return (
    <>
      {loading && (
        <Skeleton
          variant="rectangular"
          animation="wave"
          style={{ background: "lightgray", height: 300 }}
        ></Skeleton>
      )}
      {image && !loading && (
        <div className={classes["max-width-wrapper"]}>
          <div className={classes["image-grid"]}>
              <div  className={classes["image-container"]}>
                <img
                  src={image}
                  alt={`Image`}
                  className={classes["responsive-image"]}
                  loading="lazy"
                />
              </div>
            
          </div>
        </div>
      )}
    </>
  );
}
